import { SPORT_SESSION_TYPES } from './sport.session.types.schema';

export const SPORT_SESSION_TYPE_ICONS: Record<string, string> = {
  [SPORT_SESSION_TYPES.SPORT_SESSION]: 'fa-watch-fitness',
  [SPORT_SESSION_TYPES.SPORT_SESSION_RUN]: 'fa-person-running',
  [SPORT_SESSION_TYPES.SPORT_SESSION_BIKE]: 'fa-person-biking',
  [SPORT_SESSION_TYPES.SPORT_SESSION_SWIM]: 'fa-person-swimming fa-flip-horizontal',
  [SPORT_SESSION_TYPES.SPORT_SESSION_FITNESS]: 'fa-dumbbell',
  [SPORT_SESSION_TYPES.SPORT_SESSION_STRENGTH]: 'fa-dumbbell',
  [SPORT_SESSION_TYPES.SPORT_SESSION_YOGA]: 'fa-spa',
  [SPORT_SESSION_TYPES.SPORT_SESSION_HIKE]: 'fa-person-hiking',
  [SPORT_SESSION_TYPES.SPORT_SESSION_WALKING]: 'fa-person-walking',
  [SPORT_SESSION_TYPES.SPORT_SESSION_OTHER]: 'fa-dumbbell',
  [SPORT_SESSION_TYPES.SPORT_SESSION_TRANSITION]: 'fa-repeat',
};

export const SPORT_SESSION_TYPE_DEFAULT_ICON = 'fa-watch-fitness';
